import LineSymbol from './LineSymbol';
import Template from '../geometry/Template';
import Vector from '../math/Vector';
import SymbolFactory from './SymbolFactory';

/**
 * 由点符号构成的线符号,每隔指定间距绘制一遍点符号
 */
export default class MarkerLineSymbol extends LineSymbol {
    constructor(options) {
        super(options);

        this.pattern = [];
        this.startOffset = 0;
        this.direction = 's2e';
        this.marker = null;
        this.type = 'MarkerLineSymbol';

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        this._setValue('pattern', json.pattern);
        this._setValue('startOffset', json.startOffset);
        this._setValue('direction', json.direction);
        if (json.marker) {
            const symbolFactory = SymbolFactory.getInstance();
            this.marker = symbolFactory.createSymbol(json.marker);
        }
    }

    toJson() {
        const json = super.toJson();

        json.pattern = this.pattern;
        json.startOffset = this.startOffset;
        json.direction = this.direction;
        if (this.marker) {
            json.marker = this.marker.toJson();
        }

        return json;
    }

    /**
     * 绘制接口.
     * @param {object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @returns {undefined}
     */
    draw(ctx, geometry) {
        if (!this.marker || !this.pattern) {
            return;
        }
        if (!geometry || !geometry.coordinates || geometry.coordinates.length < 2) {
            return;
        }

        const template = new Template();
        template.startOffset = this.startOffset;
        template.pattern = this.pattern;
        if (this.direction === 's2e') {
            template.lineString = geometry;
        } else {
            template.lineString = geometry.reverse();
        }
        const segments = template.getSegments();
        for (let i = 0; i < segments.length; ++i) {
            this._drawSegment(ctx, segments[i], template);
        }
    }

    /**
     * 绘制一个小段,绘制前先将线按照template的pattern属性切成N段,然后绘制每一段.
     * @param {object} ctx - 设备上下文
     * @param {object} segment
     * @param [template]{@link Template} template - template对象
     * @return {undefined}
     */
    _drawSegment(ctx, segment, template) {
        // 在每段mark的第一个坐标处绘制marker，方向取当前形状边方向
        const marks = template.getMarks(segment);
        for (let i = 0; i < marks.length; ++i) {
            const mark = marks[i];
            const vY = new Vector(0, -1);
            const vN = mark.coordinates[1].minus(mark.coordinates[0]);

            let angle = vY.angleTo(vN);
            const signal = vY.cross(vN);

            if (signal < 0) {
                angle = -angle;
            }

            this._drawMarker(ctx, angle, mark.coordinates[0]);
        }
    }

    /**
     * 私有方法.
     * @param {object} ctx - 设备上下文
     * @param {Number} angle - marker符号的角度
     * @param {object} geometry 几何对象
     */
    _drawMarker(ctx, angle, geometry) {
        this.marker.angle = angle;
        this.marker.draw(ctx, geometry);
    }
}
